import React from "react";
import logo from "../assets/images/logo-acg-vo.jpg";
import "../assets/styles/components/Header.css";

const Header = () => {
  const closeMenu = () => {
    const navbarCollapse = document.getElementById("navbarNav");
    if (navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  return (
    <header className="acgvo-header">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          {/* Logo with link */}
          <a className="navbar-brand" href="#home">
            <img src={logo} alt="ACG-VO Logo" className="acgvo-logo" />
          </a>

          {/* Toggler for smaller screens */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Navigation menu */}
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link active" href="#root" onClick={closeMenu}>
                  Accueil
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services" onClick={closeMenu}>
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#a-propos" onClick={closeMenu}>
                  Info
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact" onClick={closeMenu}>
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
